<template>
  <div>
    <BeautifyHeader jsBeautify/>
    <v-container>
      <v-row>
        <v-col cols="8">
          <v-textarea
            outlined
            name="input-10-6"
            label="Code"
            rows='8'
            v-model="code"
          ></v-textarea>
          <v-btn block color="primary" dark @click="handleBeautify()">Beautify</v-btn>
          <br/>
          <v-textarea
            outlined
            name="input-10-6"
            label="Beautified"
            rows='8'
            v-model="beautified"
          ></v-textarea>
        </v-col>
        <v-col cols="4">
          <p>Did you know?</p>
          <ul>
            <li>Beautifying Javascript code enhances code readability!</li>
            <li>Beautified JS code <code>==</code> Improved debugging!</li>
            <li>Beautifying Javascript will reduce extra line breaks! Hence saves space!</li>
            <li>Beautifiers reduces the ugliness of your JS code!</li>
            <li>Beautifiers improves the indentation in your JS code!</li>
            <li>Beautified JS code enhances team co-ordination among Developers!</li>
          </ul>
        </v-col>
      </v-row>
    </v-container>      
  </div>
</template>

<script>

import PrismEditor from "vue-prism-editor";
import "prismjs";
import "prismjs/themes/prism.css";
import "vue-prism-editor/dist/VuePrismEditor.css";

export default {
  components: {
    PrismEditor,
    BeautifyHeader: () => import('./BeautifyHeader.vue')   
  },
  data() {
    return {
      code: "",
      beautified: "",
      name: "JS Beautifier"
    };
  },
  created () {
      document.title = "Online Javascript Beautifier - Encodify";
  },
  methods: {
    handleBeautify() {
      var beautify_js = require("js-beautify");
      let spec = { indent_size: 4, space_in_empty_paren: true };
      this.beautified = beautify_js(this.code, spec);
    }
  }
};
</script>
